import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import AccordionSummaryCard from './AccordionSummaryCard';

const SummaryCardPicker = (props) => {
  const { resource } = useMetaLayoutContext();

  return pickFunction(resource, {
    [fr.relationships.default.name]: () => {
      return (
        <AccordionSummaryCard {...props} />
      );
    },
  });
};

export default SummaryCardPicker;
